export const computeRoi = (totalInvested: number, currentValue: number): number => {
  if (!totalInvested || !currentValue) return 0.0

  return totalInvested <= 0.000000000001 ? 0.0 : (currentValue / totalInvested - 1.0) * 100.0
}
